import gql from 'graphql-tag'

export const fetchAvailablePackagingQuery = gql`
 query ($sku: String, $sap_sub_brand_code: String) {
  getProductAvaliablePackaging(
    sku: $sku,
    sap_sub_brand_code: $sap_sub_brand_code
  ){
    type
    volume
    title
    your_price
    your_price_tax
    sku
  }
}
`
